<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>{{ $route.meta.title }}</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
			<br>
			<!-- main row for all icons  -->
			<div class="col-lg-12">
				<div class="card card-primary card-outline">
					<div class="card-header">
						Collection Report
					</div>
					<div class="card-body overflow-auto">
						<div class="row">
							<div class="form-group">
								<label>From</label>
								<input type="date" class="form-control" v-model="from">
							</div>
							<div class="form-group">
								<label>To</label>
								<input type="date" class="form-control" v-model="to">
							</div>
							<div class="form-group">
								<label>Branch</label>
								<v-select v-model="branch" :options="branches" :reduce="branches => branches.branch_code" placeholder="Select branch" label="branch"></v-select>
							</div>
							<div class="form-group">
								<label>Zone</label>
								<v-select v-model="zone" :options="zones" :reduce="zones => zones.zone_code" placeholder="Select zone" label="name"></v-select>
							</div>
							<div class="form-group">
								<button class="btn btn-primary" @click="getTotals">Search</button>
							</div>
						</div>
						{{receipttotal}}
					</div>
					<div class="card-footer">

					</div>
				</div>
			</div>
    </section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
		 export default {
        mounted() {
            console.log('Component mounted.')
        },

        data(){
        	return {
        		receipttotal: '',
        		modes: [],
        		from: '',
        		to: '',
        		branch: '',
        		zone: ''
        	}
        },

        methods: {
        	getTotals(){
        		axios.post("/api/getReceiptTotal", {from: this.from, to: this.to, branch: this.branch, zone: this.zone})
        		.then(response => {
        			this.receipttotal = response.data;
        		});
        		axios.post("/api/getPaymentModesTotal", {from: this.from, to: this.to, branch: this.branch, zone: this.zone})
        		.then(response => {
        			this.modes = response.data;
        		});
        	}
        }
    }
</script>
